export const MOCK_TICKET_DETAILS = {
  entity: {
    _schema: 'ticket',
    meter_id: 'b0da1270-c363-4aa3-9a7e-653e24629427',
    counter_id: '1cac569f-a9f2-4795-ac56-17325d31b758',
    value: 1,
    direction: 'feed-out',
    reading_timestamp: '2025-11-28T10:24:28.202Z',
    read_by: 'Flo Tester',
    reading_source: 'ECP',
    meter_reading_status: ['valid'],
    metadata: {
      current_contract_id: '313da0d2-b20a-414d-97bf-6784fd898147'
    },
    _id: 'd2344f3c-22b0-4fd2-996f-1d029b203b77',
    _org: '911744',
    _owners: [
      {
        org_id: '911744',
        user_id: 'unknown'
      }
    ],
    _created_at: '2025-11-28T10:24:33.646Z',
    _updated_at: '2025-11-28T10:24:35.719Z',
    ticket_number: 'T-102',
    source: {
      href: null,
      source_type: 'manual',
      title: 'manual'
    },
    _title: 'T-102',
    _acl: {
      view: ['org_911744'],
      edit: ['org_911744'],
      delete: ['org_911744']
    },
    meter: {
      $relation: [
        {
          entity_id: 'b0da1270-c363-4aa3-9a7e-653e24629427'
        }
      ]
    },
    meter_counter: {
      $relation: [
        {
          entity_id: '1cac569f-a9f2-4795-ac56-17325d31b758'
        }
      ]
    },
    contract: {
      $relation: [
        {
          entity_id: '313da0d2-b20a-414d-97bf-6784fd898147'
        }
      ]
    }
  },
  relations: [
    {
      ma_lo_id: '9349294234',
      meter_type: 'three-phase-meter',
      meter_number: '23452353345',
      sector: 'power',
      _tags: [],
      _schema: 'meter',
      _id: 'b0da1270-c363-4aa3-9a7e-653e24629427',
      _org: '911744',
      _owners: [
        {
          org_id: '911744',
          user_id: '11001152'
        }
      ],
      _created_at: '2025-10-31T13:15:28.483Z',
      _title: '23452353345',
      _acl: {
        view: ['org_911744'],
        edit: ['org_911744'],
        delete: ['org_911744']
      },
      counters: {
        $relation: [
          {
            entity_id: '1cac569f-a9f2-4795-ac56-17325d31b758',
            _tags: []
          }
        ]
      },
      contract: {
        $relation: [
          {
            entity_id: '313da0d2-b20a-414d-97bf-6784fd898147'
          }
        ]
      },
      _updated_at: '2025-11-28T15:01:14.489Z',
      _files: {
        $relation: [
          {
            entity_id: '50b28327-fb66-40c0-9314-8feae7f21852'
          },
          {
            entity_id: 'cb8ccc9f-a93d-4806-89af-16c5fefdc3d9'
          },
          {
            entity_id: 'c30d0b14-2f78-460f-9edc-e310957c92e3'
          },
          {
            entity_id: 'c90f5508-a4ac-47c3-beb6-957d5f24f956'
          }
        ]
      }
    },
    {
      obis_number: '546456546',
      direction: 'feed-out',
      tariff_type: 'ht',
      unit: 'kWh',
      _tags: [],
      _schema: 'meter_counter',
      _id: '1cac569f-a9f2-4795-ac56-17325d31b758',
      _org: '911744',
      _owners: [
        {
          org_id: '911744',
          user_id: '11001152'
        }
      ],
      _created_at: '2025-10-31T13:16:04.636Z',
      _updated_at: '2025-10-31T13:16:04.636Z',
      _title: '546456546',
      _acl: {
        view: ['org_911744'],
        edit: ['org_911744'],
        delete: ['org_911744']
      }
    },
    {
      contract_name: 'Flex 12',
      contract_number: '5345345345',
      start_date: '2025-10-01',
      customer: {
        $relation: [
          {
            entity_id: 'c78197c7-4c97-44c1-8c53-50772e1ba085',
            _schema: 'contact',
            _tags: []
          },
          {
            entity_id: 'c76f0d6f-8d4e-4cda-9619-8b1b85eae31d',
            _schema: 'account',
            _tags: []
          }
        ]
      },
      type: 'one_time',
      installment_amount: 0,
      installment_amount_currency: 'EUR',
      installment_amount_decimal: '0.00',
      balance: 200,
      balance_currency: 'EUR',
      balance_decimal: '200.00',
      _schema: 'contract',
      status: 'active',
      _id: '313da0d2-b20a-414d-97bf-6784fd898147',
      _org: '911744',
      _owners: [
        {
          org_id: '911744',
          user_id: '11001152'
        }
      ],
      _created_at: '2025-10-31T13:15:04.190Z',
      billing_period: 'weekly',
      billing_duration_unit: 'months',
      notice_time_unit: 'months',
      termination_time_unit: 'months',
      renewal_duration_unit: 'months',
      _title: 'Flex 12',
      _acl: {
        view: ['org_911744'],
        edit: ['org_911744'],
        delete: ['org_911744']
      },
      billing_account: {
        $relation: [
          {
            entity_id: '63710f17-6bcf-43e6-b9be-15f1ee2acbdb'
          }
        ]
      },
      _updated_at: '2025-12-11T08:24:19.066Z',
      line_items: [
        {
          price_id: '31d38b3a-747a-44f4-bba0-f9e599c016df',
          product_id: 'fc038fca-5106-4f36-ae42-bee0bd3788b8',
          quantity: 1,
          description: 'Base',
          unit_amount: 14900,
          unit_amount_decimal: '149',
          pricing_model: 'per_unit',
          _price: {
            description: 'Base',
            pricing_model: 'per_unit',
            unit_amount: 14900,
            unit_amount_currency: 'EUR',
            unit_amount_decimal: '149.00',
            is_tax_inclusive: true,
            price_display_in_journeys: 'show_price',
            active: true,
            type: 'one_time',
            billing_duration_unit: 'months',
            notice_time_unit: 'months',
            termination_time_unit: 'months',
            renewal_duration_unit: 'months',
            internal_description: 'Base',
            _tags: [],
            _id: '31d38b3a-747a-44f4-bba0-f9e599c016df',
            billing_period: 'weekly',
            _title: 'Base'
          },
          _product: {
            name: 'Test Product',
            type: 'product',
            active: true,
            price_options: [
              {
                description: 'Base',
                pricing_model: 'per_unit',
                unit_amount: 14900,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '149.00',
                is_tax_inclusive: true,
                price_display_in_journeys: 'show_price',
                active: true,
                type: 'one_time',
                billing_duration_unit: 'months',
                notice_time_unit: 'months',
                termination_time_unit: 'months',
                renewal_duration_unit: 'months',
                internal_description: 'Base',
                _tags: [],
                _schema: 'price',
                _id: '31d38b3a-747a-44f4-bba0-f9e599c016df',
                _org: '911744',
                _owners: [
                  {
                    org_id: '911744',
                    user_id: '11001152'
                  }
                ],
                _created_at: '2025-11-25T09:38:08.165Z',
                _updated_at: '2025-11-25T09:38:08.165Z',
                billing_period: 'weekly',
                _title: 'Base',
                _acl: {
                  view: ['org_911744'],
                  edit: ['org_911744'],
                  delete: ['org_911744']
                },
                $relation: {
                  entity_id: '31d38b3a-747a-44f4-bba0-f9e599c016df',
                  _tags: []
                }
              }
            ],
            internal_name: 'Testing Product',
            _id: 'fc038fca-5106-4f36-ae42-bee0bd3788b8',
            _title: 'Test Product',
            _messages: {}
          },
          taxes: [
            {
              rate: 'nontaxable',
              rateValue: 0,
              amount: 0
            }
          ],
          unit_amount_net: 14900,
          unit_amount_gross: 14900,
          amount_subtotal: 14900,
          amount_total: 14900,
          amount_tax: 0,
          currency: 'EUR',
          type: 'one_time',
          is_tax_inclusive: true,
          unit_amount_net_decimal: '149',
          unit_amount_gross_decimal: '149',
          amount_subtotal_decimal: '149',
          amount_total_decimal: '149'
        }
      ],
      amount_subtotal: 14900,
      amount_total: 14900,
      total_details: {
        amount_tax: 0,
        breakdown: {
          taxes: [
            {
              tax: {
                rate: 0
              },
              amount: 0
            }
          ],
          recurrences: [
            {
              type: 'one_time',
              unit_amount_gross: 14900,
              unit_amount_net: 14900,
              amount_subtotal: 14900,
              amount_total: 14900,
              amount_subtotal_decimal: '149',
              amount_total_decimal: '149',
              amount_tax: 0
            }
          ],
          recurrencesByTax: [
            {
              type: 'one_time',
              amount_total: 14900,
              amount_subtotal: 14900,
              amount_tax: 0,
              tax: {
                tax: {
                  rate: 0
                },
                amount: 0
              }
            }
          ],
          cashbacks: []
        }
      },
      currency: 'EUR',
      redeemed_promos: [],
      amount_tax: 0,
      prices: {
        $relation: [
          {
            entity_id: '31d38b3a-747a-44f4-bba0-f9e599c016df',
            _schema: 'price',
            _tags: []
          }
        ]
      },
      products: {
        $relation: [
          {
            entity_id: 'fc038fca-5106-4f36-ae42-bee0bd3788b8',
            _schema: 'product',
            _tags: []
          }
        ]
      },
      _tags: [],
      payment: {
        $relation_ref: [
          {
            entity_id: 'c78197c7-4c97-44c1-8c53-50772e1ba085',
            path: 'payment',
            _id: 'bGBfpKlFCJAkKw2AC05eR'
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: '50b28327-fb66-40c0-9314-8feae7f21852'
          },
          {
            entity_id: 'cb8ccc9f-a93d-4806-89af-16c5fefdc3d9'
          },
          {
            entity_id: 'c30d0b14-2f78-460f-9edc-e310957c92e3'
          },
          {
            entity_id: 'c90f5508-a4ac-47c3-beb6-957d5f24f956'
          }
        ]
      },
      abrechnungsvertraege: {
        $relation: [
          {
            entity_id: '0388c5be-aadd-4adb-88c3-d95ff8923a68',
            _schema: 'contract',
            _tags: []
          },
          {
            entity_id: 'bd82849a-2921-49eb-8b23-9af85e37f015',
            _schema: 'contract',
            _tags: []
          }
        ]
      }
    }
  ]
}
